import httpClient from '@/lib/httpClient'
// import useAppStore from '@/store/useAppStore'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { formatDate } from 'date-fns'
import { toast } from 'sonner'

export default function useSortVault({
  // setError = null,
  // clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  // const periodType = useAppStore((state) => state.periodType)
  // const offset = useAppStore((state) => state.offset)
  // const numberOfPeriods = useAppStore((state) => state.numberOfPeriods)

  const action = async ({
    id,
    entityType,
    sortOrder,
  }: {
    id: string | number
    entityType: 'vaults' | 'vault_groups'
    sortOrder: number
  }) => {
    const response = await httpClient.put(`team/vault/sort-order`, {
      id,
      entity_type: entityType,
      sort_order: sortOrder,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Order updated')
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
    },
    onError: (error, variables, context) => {
      // queryClient.setQueryData(['vault'], context.previousVaults)
      toast.error(error?.response?.data?.message ?? 'An error occurred.')
    },

    // handleFormError({
    //   error,
    //   variables,
    //   setError,
    //   clientServerFieldMapping,
    // }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
